import React from "react";

const LazyPie = React.lazy(() =>
  import('react-chartjs-2').then(mod => ({ default: mod.Pie }))
);
export default LazyPie;
